
import { PropTypes } from 'prop-types';
import PopupDialog from "../news/popupDialog";
import { DecodeHtml } from "../../utils/decodeHtml";
import ShowPopUp from "./rentalFacilities/showPopUp";
import { MdArrowForward } from 'react-icons/md';

const Tender = ({ training }) => {

    const title = training?.title4
    const description = training?.description4

    const programmes = training?.buttons4?.items?.map((item) => {
        item = item?.content?.properties
        return {
            name: item?.buttonLabel || item?.label,
            link: item?.link,
            children: item?.Header ? <PopupDialog title={item?.Header} paragraphs={DecodeHtml({ html: item?.description?.markup })} /> : null
        }

    }
    )
    return (
        <div className="grid gap-5">
            <h1 className="text-4xl font-bold ">{title}</h1>
            <div className="grid grid-cols-1 lg:grid-cols-[70%_30%] gap-16  place-items-start">
                <div className='flex flex-col gap-5'>
                    <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal whitespace-pre-line">{description}</p>

                </div>
                <div className="flex flex-col  gap-2">
                    {
                        programmes?.map((programme, index) => (

                            programme?.children ?
                                <ShowPopUp key={index} title={programme?.name} >
                                    {programme?.children}
                                </ShowPopUp>
                                :
                                <a href={programme?.link} target="_blank" rel="noreferrer" key={index} className="flex items-center gap-5 text-[1rem] text-[#0039CB] font-bold">
                                    <h2 className=" ">{programme.name}</h2>
                                    <MdArrowForward />
                                </a>


                        ))
                    }
                </div>

            </div>
        </div>
    )
}
Tender.propTypes = {
    training: PropTypes.any
}
export default Tender